import {
  Box,
  Typography,
  Paper,
  Chip,
  chipClasses,
  Button,
  TextField,
} from "@mui/material";
import { Grid } from "../../../components/table";
// import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useEffect, useMemo, useState } from "react";
import FormControl from "@mui/material/FormControl";
// import { ReportsData } from './ecd-reports-database';
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PendingIcon from "@mui/icons-material/Pending";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { ToolBar } from "../../../components/toolbar";
import dayjs from "dayjs";
import { SelectA } from "../../../components/form";
import CircularProgress from "@mui/material/CircularProgress";
import { CONFIG } from "../../../../config";
import { useSelector, useDispatch } from "react-redux";

import axios from "axios";
import { isNull } from "lodash";
import ExportTelecallersRatingModal from "./features/export-rating-telecallers";
const API_HOST_CRM = CONFIG.modules["crm"].host;

let tempdata = [
  {
    agentName: "Pranim Luyang",
    overallScore: 10,
    totalCases: 10,
  },
];

const TelecallerIndividual = () => {
  const {
    roles,
    user,
    users,
    Designations,
    Departments,
    Languages,
    Districts,
    map,
  } = useSelector((state) => state.user || {});

  const [agent, setAgent] = useState();
  const [currentDate] = useState(new Date());
  const [loader, setLoader] = useState();
  const [filter, setFilter] = useState({
    from: dayjs(), // dayjs("01-01-2023"),
    to: dayjs(),
  });

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [count, setCount] = useState(0);
  const [data, setData] = useState([]);

  const [isModalExportTelecallerRatingsOpen, setModalExportTelecallerRatingsOpen] = useState(false);

  const handleModalExportTelecallerRatingsOpen = () => setModalExportTelecallerRatingsOpen(true);
  const handleModalExportTelecallerRatingsClose = () => setModalExportTelecallerRatingsOpen(false);

  // const [callReqObj, setCallReqObj] = useState({
  //     user_name: 'nhm_meghalaya',
  //     api_key: 'KK6530499e65627bd1f85eb8d669b52cf9',
  //     // from_date: currentDate?.getFullYear() + '-0' + (currentDate?.getMonth() + 1) + '-' + currentDate?.getDate() + ' ' + currentDate?.getHours() + ':' + currentDate?.getMinutes() + ':' + currentDate?.getSeconds(),
  //     // to_date: currentDate?.getFullYear() + '-0' + (currentDate?.getMonth() + 1) + '-' + (currentDate?.getDate() + 1) + ' ' + currentDate?.getHours() + ':' + currentDate?.getMinutes() + ':' + currentDate?.getSeconds(),
  //     from_date:
  //         currentDate && currentDate?.getFullYear() + '-'
  //         + (currentDate?.getMonth() < 10 ? ('0' + (currentDate?.getMonth() + 1)) : currentDate?.getMonth())
  //         + '-' + (currentDate?.getDate() < 10 ? ('0' + (currentDate?.getDate() - 1)) : currentDate?.getDate() - 1)
  //         + ' ' + (currentDate?.getHours() < 10 ? ('0' + currentDate?.getHours()) : currentDate?.getHours())
  //         + ':' + (currentDate?.getMinutes() < 10 ? ('0' + currentDate?.getMinutes()) : currentDate?.getMinutes())
  //         + ':' + (currentDate?.getSeconds() < 10 ? ('0' + currentDate?.getSeconds()) : currentDate?.getSeconds()),
  //     to_date:
  //         currentDate && currentDate?.getFullYear() + '-'
  //         + (currentDate?.getMonth() < 10 ? ('0' + (currentDate?.getMonth() + 1)) : currentDate?.getMonth())
  //         + '-' + (currentDate?.getDate() < 10 ? ('0' + currentDate?.getDate()) : currentDate?.getDate())
  //         + ' ' + (currentDate?.getHours() < 10 ? ('0' + currentDate?.getHours()) : currentDate?.getHours())
  //         + ':' + (currentDate?.getMinutes() < 10 ? ('0' + currentDate?.getMinutes()) : currentDate?.getMinutes())
  //         + ':' + (currentDate?.getSeconds() < 10 ? ('0' + currentDate?.getSeconds()) : currentDate?.getSeconds()),
  //     campaign_name: '',
  //     format: 'json'
  // })

  const [callData, setCallData] = useState();
  const [formValue, setFormValue] = useState({
    CallOpening: 1,
    Tone: 1,
    Clarity: 1,
    ActiveListening: 1,
    ProcessKnowledge: 1,
    DataIntegrity: 1,
    redFlags: "",
    FeedbackToCaller: "",
  });

  const [callList, setCallList] = useState([]);
  const [callRecording, setCallRecording] = useState(null);
  const [caseData, setCaseData] = useState(isNull);

  const handleChangeCall = (e) => {
    console.log(e.target, "for handle call data");
  };

  // useEffect(() => {
  //     fetchCallRecording();
  //     console.log(callReqObj && callReqObj, 'current date tme');
  // }, [])

  const [toolbarButtons, setToolbarButtons] = useState([
    {
      name: "Export Ratings",
      onClick: () => {
        handleModalExportTelecallerRatingsOpen();
      }
    },
    {
      name: "Today",
      // type: 'chip',
      // icon: () => <IosShareIcon sx={{ fontSize: '1.2em' }} />,
      onClick: () => {
        setFilter({ ...filter, from: dayjs(), to: dayjs() });
      },
    },
    {
      name: "This week",
      // type: 'chip',
      // icon: () => <IosShareIcon sx={{ fontSize: '1.2em' }} />,
      onClick: () => {
        const start = dayjs().weekday(0);
        const end = start.add(7, "day");
        // console.log(start.format('DD-MM-YYYY'), end.format('DD-MM-YYYY'))
        setFilter({ ...filter, from: start, to: end });
      },
    },
  ]);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    // setAnchorEl(event.currentTarget);
    console.log(event.target.textContent.trim(), "event");
    console.log(toolbarButtons && toolbarButtons, "event");
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const ratingLogicForNow = (data) => {
    let agentObject = {};

    data.forEach((d) => {
      if (!agentObject[d.caller.uuid]) {
        agentObject[d.caller.uuid] = {};
        agentObject[d.caller.uuid].qas = [d];
        agentObject[d.caller.uuid].count = 1;
      } else {
        agentObject[d.caller.uuid].qas.push(d);
        agentObject[d.caller.uuid].count += 1;
      }
    });
    let newData = [];
    console.log(agentObject);
    Object.keys(agentObject).forEach((ag) => {
      let score = 0;

      agentObject[ag].qas.forEach((qa) => {
        let newvalue =
          Number(qa.callOpening) +
          Number(qa.tone) +
          Number(qa.clarity) +
          Number(qa.activeListening) +
          Number(qa.processKnowledge) +
          Number(qa.dataIntegrity);

        console.log("new value", newvalue)
        score += Number((newvalue / 6).toFixed(2));
        console.log(score, "score in loop")
      });

      let average = (score / (6 * agentObject[ag].count)) * 6;
      console.log("score", score);
      console.log(average, "average")

      newData.push({
        agentName: agentObject[ag].qas[0].agentID,
        totalCases: agentObject[ag].count,
        overallScore: average.toFixed(2),
      });
    });
    return newData;
  };

  const getAgentsQA = () => {
    // quality assurances route
    try {
      axios
        .get(
          API_HOST_CRM +
          `/quality-assurance?limit=${rowsPerPage}` +
          `&page=${page}` +
          `${filter.from
            ? `&from=${dayjs(filter.from).format("YYYY-MM-DD")}`
            : ""
          }` +
          `${filter.to ? `&to=${dayjs(filter.to).format("YYYY-MM-DD")}` : ""
          }` +
          `${filter.agentName ? `&agentName=${filter.agentName}` : ""}` +
          `${filter.overallScore ? `&overallScore=${filter.overallScore}` : ""
          }` +
          `${filter.week ? `&week=${filter.week}` : ""}`
        )
        .then((resp) => {
          if (resp.data && resp.data.success) {
            console.log("quality assurances", resp.data.qa);
            const newData = ratingLogicForNow(resp.data.qa);
            setData(newData);
            setCount(resp.data.count - 1);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } catch (e) { }
  };

  const fetchTelecallersRatings = async () => {
    try {
      const response = await axios.get(API_HOST_CRM + `/quality-assurance/telecallers/rating?` +
        `&limit=${rowsPerPage}` +
        `&page=${page}` +
        `${filter.from
          ? `&from=${dayjs(filter.from).format("YYYY-MM-DD")}`
          : ""
        }` +
        `${filter.to ? `&to=${dayjs(filter.to).format("YYYY-MM-DD")}` : ""
        }` +
        `${filter.agentName ? `&agentName=${filter.agentName}` : ""}` +
        `${filter.overallScore ? `&overallScore=${filter.overallScore}` : ""
        }` +
        `${filter.week ? `&week=${filter.week}` : ""}`
        , {});
      setData(response.data.data);
      setCount(response.data.count);
      console.log(response.data, "give me a response you fool.");
    } catch (error) {
      console.log(error);
    }
  }

  // useEffect(() => {
  //   fetchTelecallersRatings();
  // }, [])

  // sideeffects use effect
  // will run every time there is a chage on the column input
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      // getAgentsQA();
      fetchTelecallersRatings();
    }, 500);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [filter, page, rowsPerPage]);

  return (
    <Box sx={{ display: "flex" }}>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ mt: 2, display: "flex", flexDirection: "column", flex: 1 }}>
          <Box>
            <Typography variant="h5">Telecallers Rating</Typography>
          </Box>
          <Paper
            elevation={3}
            sx={{
              height: "80vh",
              overflowY: "scroll",
              width: "100%",
              padding: 2,
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <ToolBar
                name={""}
                buttons={toolbarButtons}
                open={open}
                flex={"column"}
                height={"100%"}
                handleClose={handleClose}
                anchorEl={anchorEl}
                handleClick={handleClick}
                filters={[
                  {
                    field: {
                      name: "from",
                      type: "date",
                      label: "From Date",
                    },
                    onChange: (name, value) => {
                      filter[name] = value;
                      setFilter({ ...filter });
                    },
                    state: filter,
                  },
                  {
                    field: {
                      name: "to",
                      type: "date",
                      label: "To Date",
                    },
                    onChange: (name, value) => {
                      filter[name] = value;
                      setFilter({ ...filter });
                    },
                    state: filter,
                  },
                ]}

              />
              <Box sx={{ mt: 2 }}>
                <Grid
                  isSelectEnabled={false}
                  data={data}
                  columns={[
                    {
                      id: "agentID",
                      label: "Agent Name",
                      minWidth: 70,
                      //   editable: true,
                      //   onChange: (name, value) => {
                      //     filter[name] = value;
                      //     setFilter({ ...filter });
                      //   },
                      //   field: {
                      //     name: "agentName",
                      //     type: "text",
                      //     label: "Agent Name",
                      //   },
                      //   state: filter,
                    },
                    {
                      id: "totalScore",
                      label: "Overall Score",
                      minWidth: 70,
                      //   editable: true,
                      //   onChange: (name, value) => {
                      //     filter[name] = value;
                      //     setFilter({ ...filter });
                      //   },
                      //   field: {
                      //     name: "overallScore",
                      //     type: "number",
                      //     label: "Overall Score",
                      //   },
                      //   state: filter,
                    },
                    {
                      id: "count",
                      label: "Total Cases",
                      minWidth: 70,
                      //   editable: true,
                      //   onChange: (name, value) => {
                      //     filter[name] = value;
                      //     setFilter({ ...filter });
                      //   },
                      //   field: {
                      //     name: "totalCases",
                      //     type: "number",
                      //     label: "Total Cases",
                      //   },
                      //   state: filter,
                    },
                  ]}
                  pagination={{
                    rowsPerPageOptions: [10, 25, 50],
                    page,
                    rowsPerPage,
                    onPageChange: (event, newPage) => {
                      setPage(newPage);
                    },
                    onRowsPerPageChange: (event) => {
                      setRowsPerPage(+event.target.value);
                      setPage(0);
                    },
                    count,
                  }}
                ></Grid>
              </Box>
            </Box>
          </Paper>
        </Box>
      </Box>
      <ExportTelecallersRatingModal 
        open={isModalExportTelecallerRatingsOpen}
        handleClose={() => handleModalExportTelecallerRatingsClose()}
        handleOpen={() =>handleModalExportTelecallerRatingsOpen()}
      />
    </Box>
  );
};

export default TelecallerIndividual;
